import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { CTAButton } from '../ui/CTAButton';
import { faqs } from '../../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-16 md:py-24" data-id="element-143" data-mp="2z3h3qcxlphl6">
      <div className="mx-auto max-w-3xl" data-id="element-144" data-mp="3msjind0uowbz">
        <SectionHeader kicker="Frequently asked questions" title="Everything You Need to Know Before Purchasing" data-id="element-145" data-mp="3muw9kfol6h16" />

        <ul className="mt-10 space-y-3" data-id="element-146" data-mp="3rtqpn9v65rhl">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} className="overflow-hidden rounded-2xl bg-paper" data-id="element-147" data-mp="3i1bb6mj2zl1g" data-mpi={i}>
                <h3 data-id="element-148" data-mp="9lribombo4mx">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left" data-id="element-149" data-mp="9lhr5xpjjrfn">
                    <span className="font-display text-[17px] font-extrabold leading-snug text-heading" data-id="element-150" data-mp="1vsez72ew3u8y">{faq.question}</span>
                    <PlusIcon className={`h-6 w-6 shrink-0 text-blue transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-151" data-mp="2ai2zq1f8yovm" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-152" data-mp="2eiwqd2k2qhs7">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-153" data-mp="2tfxhb3ufy8pm">
                      <div className="space-y-3 px-5 pb-5 text-[16px] leading-relaxed text-body" data-id="element-154" data-mp="u31rgtqrsquc">
                        {faq.answer.map(p => <p key={p} data-id="element-155" data-mp="1jsibjta6hj0a">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-156" data-mp="1xqq2nkkj9q3j">
          <CTAButton label="I'm ready — get the Blueprint" sub="One-time payment · $27 USD · Digital product" tone="light" data-id="element-157" data-mp="1xqzvrh0vkddg" />
        </div>
      </div>
    </section>;
}